import mitt from 'mitt';

type Events = {
    'hide-all-dropdowns': string,
};
export default mitt<Events>();
